import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "@/store/interfaces/root";

import { root } from "@/store/modules/root";
import { user } from "@/store/modules/user";
import { company } from "@/store/modules/company";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {
    root,
    user,
    company
  }
};

export default new Vuex.Store<RootState>(store);
